import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { useEffect, useState } from "react";

const Home = () => {
    const { auth } = useAuth();
    const [stats, setStats] = useState({});
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get("/stats", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setStats(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate]);

    return (
        <div>
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Dashboard</span>
                </span>
            </div>
            <div style={{display: 'flex', columnGap: '1.5rem', justifyContent:'space-between'}}>
                <article className="rounded-lg border border-gray-200 bg-slate-100 p-6 w-1/5">
                    <div>
                        <p className="text-sm text-gray-500">Total</p>

                        <p className="text-2xl font-medium text-gray-900">{stats.total_numbers}</p>
                    </div>
                </article>

                <article className="rounded-lg border border-gray-200 bg-slate-100 p-6 w-1/5">
                    <div>
                        <p className="text-sm text-gray-500">Saved Only</p>

                        <p className="text-2xl font-medium text-gray-900">{stats.saved_numbers}</p>
                    </div>
                </article>

                <article className="rounded-lg border border-gray-200 bg-slate-100 p-6 w-1/5">
                    <div>
                        <p className="text-sm text-gray-500">Awaiting Approval</p>

                        <p className="text-2xl font-medium text-gray-900">{stats.pending_numbers}</p>
                    </div>
                </article>

                <article className="rounded-lg border border-gray-200 bg-slate-100 p-6 w-1/5">
                    <div>
                        <p className="text-sm text-gray-500">Approved</p>

                        <p className="text-2xl font-medium text-gray-900">{stats.approved_numbers}</p>
                    </div>
                </article>

                <article className="rounded-lg border border-gray-200 bg-slate-100 p-6 w-1/5">
                    <div>
                        <p className="text-sm text-gray-500">Numbers saved today</p>

                        <p className="text-2xl font-medium text-gray-900">{stats.new_numbers}</p>
                    </div>
                </article>
            </div>
        </div>
    )
}

export default Home